import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import FormVersionFieldMappingInfoCard from './FormVersionFieldMappingInfoCard';

const FormVersionFieldMappingPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dsbFormVersionId = Number(id);
  const navigate = useNavigate();
  if (isNaN(dsbFormVersionId)) {
    navigate('/404', { replace: true });
    return null;
  }

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:config_forms.dsb_form_versions.meta.title')} />
      <FormVersionFieldMappingInfoCard dsbFormVersionId={dsbFormVersionId} />
    </ContentLayout>
  );
};

export default FormVersionFieldMappingPage;
